import { makeStyles, withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Tooltip } from "@mui/material";
import { useParams } from "react-router-dom";

const BorderLinearProgress = withStyles((theme) => {
  return {
    root: {
      borderRadius: 5,
      width: 20,
      height: "100%",
    },
    colorPrimary: {
      backgroundColor: "#E7E7E7",
    },
    bar: {
      borderRadius: 5,
      transform: ({ value }) => {
        return `translateY(${value}%) !important`;
      },
      backgroundColor: "#1a90ff",
    },
  };
})(LinearProgress);

// Inspired by the former Facebook spinners.

const styles = {
  root: {
    width: "fit-content",
    height: "100%",
    gap: 10,
    display: "flex",
    justifyContent: "center",
    padding: 10,
  },
  stats: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
};

export const VerticalLinearBar = ({ data, title, unit, sensor }) => {
  //   const classes = useStyles();
  console.log("DATA VERTICAL", data);
  const handleValue = (value) => {
    let valueData = value;
    let upperBenchmark;
    console.log("spliut", sensor);
    if (sensor.toLowerCase() === "force") {
      upperBenchmark = 4200; // SOON CHANGES THIS
    } else if (sensor.toLowerCase() === "pressure") {
      upperBenchmark = 800; // SOON CHANGES THIS
    } else if (
      sensor.toLowerCase() === "temperature" ||
      sensor.toLowerCase() === "humidity"
    ) {
      upperBenchmark = 100;
      valueData = valueData.value[sensor.toLowerCase()];
    }

    // if(sensor)
    if (valueData < 0) valueData = valueData * -1;
    const rawPercentage = (valueData / upperBenchmark) * 100;
    const verticalPercentage = (rawPercentage - 100) * -1;

    return { verticalPercentage, rawPercentage };
  };

  const handleViewVerticalBar = () => {
    return (
      <div style={styles.root}>
        <div style={styles.stats}>
          <label style={{ fontSize: "15px" }}>
            {`${title} (${handleValue(data).rawPercentage.toFixed(0)} ${unit})`}
          </label>
          <Tooltip
            title={`${handleValue(data).rawPercentage.toFixed(0)}%`}
            placement="right"
          >
            <BorderLinearProgress
              variant="determinate"
              value={handleValue(data).verticalPercentage}
            />
          </Tooltip>
        </div>
      </div>
    );
  };
  return sensor && handleViewVerticalBar();
};
